import { render } from "./module4.vue?vue&type=template&id=307238dc&scoped=true"
const script = {}

import "./module4.vue?vue&type=style&index=0&id=307238dc&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-307238dc"]])

export default __exports__